import TabBar from './TabBar';

export default TabBar;
